import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';
import {cloneObject, getParam} from '../utils/utils';


import dsd from "../classes/clsDSD";

import Buffering from "../components/Buffering";
import ViewArtefact from "../components/ViewArtefact";
import ViewMetadata from "../components/ViewMetadata";
import ListProcesses from "../components/ListProcesses";

import Rendition from '../components/Rendition';


import FormResources from "../components/FormResources";
import { getArtefact, addArtefact, editArtefact } from '../utils/utilsArtefact';

class Artefact extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            isLoaded: false,
            renderState: 'loading',
            errorMessage: ''
        };


        this.data = {};

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.updateResources = this.updateResources.bind(this);


        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/artefacts`;


    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadArtefact(id){
        
        if (id === undefined){
            return;
        }

        this.setState({
            renderState: 'loading'
        });

        getArtefact(
            this.dsd, 
            id,
            (Artefact) => {
                // Update breadcrumb
                for (var i in window.Breadcrumb){
                    if (window.Breadcrumb[i][0] === 'artefact'){
                        window.Breadcrumb = window.Breadcrumb.slice(0,i);
                        break;
                    }
                }
                this.Breadcrumb = JSON.parse(JSON.stringify(window.Breadcrumb));
                window.Breadcrumb.push(['artefact',`/artefact/${id}`]);

                this.setState({
                    Artefact: Artefact,
                    FormData: Artefact,
                    ArtefactResources: Artefact.Resources || [],
                    isLoaded: true,
                    renderState: 'loaded'
                });
            }, 
            (error) => {
                this.setState({
                    renderState: 'failed',
                    errorMessage: 'Failed to load Artefact'
                });
            }
        );
        
        return;
        
    };

    setup(){

        let StateChange = {
            id: null,
            isLoaded: false,
            isUpdated: false,
            isFailed: false,
            renderState: 'loading',
            errorMessage: '',
            FormData: {},

            Artefact: null,
            ArtefactResources: null,

            action: null
        }

        StateChange.mode = getParam('mode', this.props);
        StateChange.idArtefact = getParam('id', this.props);

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        this.FallBackNavigation = `/artefacts`;

        // For "new" mode, set isLoaded and renderState immediately
        if (StateChange.mode === 'new'){
            StateChange.isLoaded = true;
            StateChange.renderState = 'loaded';
        }

        this.setState(StateChange, () => {
            // Load artefact data if in view/edit mode and idArtefact is available
            if (this.state.mode !== 'new' && this.state.idArtefact){
                this.loadArtefact(this.state.idArtefact);
            }
        });
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let FormData = this.state.FormData;
        FormData[FormFieldName] = FormFieldValue;        
        this.setState({"FormData": FormData});

    };
    
    handleSubmit(event) {

        switch (event.target.name){
            case 'btnCancel':
                switch (this.state.mode){
                    case 'new':
                        this.props.navigation(this.FallBackNavigation);
                        break;
                    case 'edit':
                       this.props.navigation(`/artefact/${this.state.idArtefact}`);
                       break;
        //            case 'remove':
        //                this.savviconfig.removeFactor(this.data.idProject,this.type,this.data.idFactor);
        //                break;  
                    default:
                        break; 
                };

                break;
            case 'btnSave':
            default:

                this.setState({
                    isUpdated: false,
                    isFailed: false
                })

                switch (this.state.mode){
                    case 'new':
                        addArtefact(
                            this.dsd,
                            this.state.FormData,
                            (idArtefact) => {
                                this.props.navigation(`/artefact/${idArtefact}`);
                            },
                            (error) => {
                                this.setState({ isFailed: true });
                            }
                        );
                        break;
                    case 'edit':
                        editArtefact(
                            this.dsd,
                            this.state.idArtefact,
                            this.state.FormData,
                            () => {
                                this.props.navigation(`/artefact/${this.state.idArtefact}`);
                            },
                            (error) => {
                                this.setState({ isFailed: true });
                            }
                        );
                        break;
        //            case 'remove':
        //                this.savviconfig.removeFactor(this.data.idProject,this.type,this.data.idFactor);
        //                break;  
                    default:
                        break; 
                };
    
        };


        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

/*        
        switch (event.target.name){
            case 'btnAddStep':

                StateChange.action = 'addStep';
                break;
        }
*/
        this.setState(StateChange);

        event.preventDefault();
    };

    updateResources(Resources){
        this.setState({FormData: {...this.state.FormData, Resources: Resources}});
    }

    render() {

        // Handle renderState for loading, failed, or denied states
        switch (this.state.renderState) {
            case 'loading':
                return <Buffering />;
            case 'failed':
                return <PD.ErrorBox>Error: {this.state.errorMessage}</PD.ErrorBox>;
            case 'denied':
                return <PD.ErrorBox>Access Denied</PD.ErrorBox>;
            default:
                break;
        }

        if (this.state.isUpdated){
            switch (this.state.mode){
                case 'remove':
                    this.props.navigation(this.FallBackNavigation);
                    return null;
                default:
                    break;
            };
        };

        if (this.state.isLoaded) {

            let boolOfferEdit = false;

            if (this.state.Artefact){
                if (this.dsd.user){
                    if (this.dsd.user.id == this.state.Artefact.idUser){
                        boolOfferEdit = true;
                    }
                }        
            }

            switch (this.state.mode){
                case 'new':
                case 'edit':
                    return (
                        <div>
                        <PD.Heading>{this.state.mode} Artefact</PD.Heading>
    
                        {this.state.isFailed &&
                            <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                        }
    
                        <form> 
                            <PD.Input label="Name" width="30" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>
                            <PD.Editor label='Description' name="description" value={this.state.FormData.description} onChange={this.handleChange}/>
                            <PD.Editor label='Proposals' name="proposals" value={this.state.FormData.proposals} onChange={this.handleChange}/>

                            <PD.Select label="Type" name='type'  onChange={this.handleChange} value={this.state.FormData.type}>
                                {
                                    Object.keys(this.dsd.model.artefacts).map(
                                        (modelKey, posModelArtefact) => 
                                            {
                                                let modelArtefact = this.dsd.model.artefacts[modelKey];
                                                return(
                                                    <option key={posModelArtefact} value={modelArtefact.name}>{modelArtefact.label}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>

                            <FormResources onUpdate={this.updateResources} Resources={this.state.FormData.Resources}/>

                            <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                                {
                                    this.dsd.config.ArtefactStatuses.map(
                                        (status, posStatus) => 
                                            {
                                                return(
                                                    <option key={posStatus} value={status}>{status}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>

                            <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave"value="Save" />    
                            <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" />    
                        </form>
    
                    </div>    
                    );
                case 'remove':
                    return (
                        <div>
                            <PD.Heading>{this.state.mode} Artefact</PD.Heading>

                            {this.state.isFailed &&
                                <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                            }

                            <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                            <ViewArtefact Artefact={this.state.Artefact}/>
                        </div>
                    )
                case 'view':
                default:

                    if (!this.state.Artefact){
                        return <div/>
                    }

//                    const countItems = this.state.countItems == null ? "Loading..." : this.state.countItems;


                    return (
                        <div>
                            <div>
                                <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                <PD.Heading>Artefact:{this.state.Artefact.name}</PD.Heading>
                            </div>

                            {boolOfferEdit &&
                                <span style={{paddingRight:10}}>
                                        <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                </span>
                            }

                            <ViewArtefact Artefact={this.state.Artefact} Resources={this.state.ArtefactResources}/>

                            <br/>


                            <PD.Tabs>

                                <div label='Developer'>
                                    <Rendition
                                        endpoint="/artefacts"
                                        id={this.state.idArtefact}
                                    />
                                </div>

                                <div label='Metadata'>
                                    <ViewMetadata Data={this.state.Artefact} />
                                </div>

                                <div label="used in ...">
                                    <ListProcesses filters={{idArtefact:this.state.idArtefact}} columns={{"owner":true}}/>
                                </div>

                            </PD.Tabs>

                        </div>
                    )
            };
        };

        return <div />;
    };
};

// Wrap and export
export default function Artefact_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Artefact {...props} navigation={navigation} location={location} params={params} />;
  }
